import { convertToFloat32 } from '../common/utils'

export interface DeviceConfig2Message {
  firmwareVersion: number
  locationGridZone: string
  locationZValue: number
}

export function decodeDeviceConfig2(data: Uint8Array): DeviceConfig2Message {
  const firmwareVersion = (data[0] << 8) | data[1]
  const locationGridZone = new TextDecoder()
    .decode(data.slice(2, -4))
    .split('\u0000')[0]
  const locationZValue = convertToFloat32(data.slice(7))

  return {
    firmwareVersion,
    locationGridZone,
    locationZValue,
  }
}
